module.exports = __webpack_public_path__ + "static/media/volume.5540cbae.svg";